/** Convert a stored preview into readable text without rendering email markup. */
export function normalizeMessagePreview(value: string | null | undefined): string {
  if (!value) return ''

  const container = document.createElement('div')
  container.innerHTML = value
  container.querySelectorAll('script, style, head, title').forEach((node) => node.remove())

  return (container.textContent || value).replace(/\s+/g, ' ').trim()
}
